export const PRELOADING_PSELECTOR = 'flomni-preloading'
export const TOGGLER_PSELECTOR = 'flomni-toggler'
export const PAGER_PSELECTOR = 'flomni-pager'
export const INVITATION_PSELECTOR = 'flomni-invitation'
